import React from 'react';
export function Footer() {
  return <footer className="w-full bg-brown py-12 px-6" data-id="element-31">
      <div className="max-w-4xl mx-auto text-center" data-id="element-32">
        <p className="font-sans text-sm text-cream/80 leading-relaxed mb-4" data-id="element-33">
          © 2024 El Código del Vientre. Todos los derechos reservados.
        </p>
        <p className="font-sans text-xs text-cream/60 leading-relaxed max-w-2xl mx-auto" data-id="element-34">
          Este material tiene propósitos educativos y de desarrollo personal. No
          reemplaza el consejo médico profesional. Consulta siempre con tu
          médico especialista sobre cualquier condición de salud.
        </p>
      </div>
    </footer>;
}